const CreateMeme = () => {
    return (
        <div>
          <h1>Creating memes here </h1>
           
        </div>
    )
}

export default CreateMeme
